<template>
  <div class="monitor-container">
    <!-- Thanh tiêu đề tự chế chuẩn dự án -->
    <v-toolbar dense flat class="custom-header">
      <v-icon class="mr-2">mdi-monitor-dashboard</v-icon>
      <v-toolbar-title class="font-weight-medium">Giám sát vận hành</v-toolbar-title>
    </v-toolbar>

    <div class="iframe-wrapper">
      <v-sheet class="fill-height" v-if="iframeUrl">
        <iframe :src="iframeUrl" width="100%" height="100%" allowfullscreen></iframe>
      </v-sheet>

      <v-sheet class="fill-height d-flex align-center justify-center" v-else-if="!loading">
        <h3>Chưa cấu hình đường dẫn Hệ thống Giám sát (Grafana) trong hệ thống.</h3>
      </v-sheet>

      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { API_SETTING } from '@src/service/api'

export default {
  name: 'MonitorDashboard',
  data() {
    return {
      iframeUrl: null,
      loading: true,
    }
  },
  async created() {
    try {
      this.loading = true;
      const res = await API_SETTING.getGrafanaUrl();
      if (res && res.isDone && res.data && res.data.data && res.data.data.url) {
        this.iframeUrl = res.data.data.url;
      } else if (res && res.data && res.data.url) {
        this.iframeUrl = res.data.url;
      }
    } catch (error) {
      console.error("Lỗi khi tải cấu hình Grafana", error);
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.monitor-container {
  width: 100%;
  /* Trừ đi Navbar (64px) và Footer (33px) */
  height: calc(100vh - 64px - 33px);
  display: flex;
  flex-direction: column;
}

.custom-header {
  flex: 0 0 48px;
  /* Độ cao của thanh tiêu đề (dense toolbar) */
  border-bottom: 1px solid #e0e0e0;
}

.iframe-wrapper {
  flex: 1;
  overflow: hidden;
  /* Cắt phần tràn của Iframe */
}

/* Cắt bay phần Header cũ (55px) bên trên và chữ Powered by (35px) bên dưới */
.iframe-wrapper iframe {
  width: 100%;
  height: calc(100% + 90px);
  /* 55 + 35 = 90 */
  margin-top: -55px;
  margin-bottom: -35px;
  border: 0;
  display: block;
}
</style>
